module.exports = __webpack_public_path__ + "img/rencaizhaopin.515a4228.jpg";